import React from 'react';
import { I18n } from 'aws-amplify';
import { Link } from 'react-router-dom'
import { connect } from 'react-redux';

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => {
    return {
    };
};

class Menu extends React.Component {
    constructor(props) {
        super();
        this.state = {
        };
    }

    componentWillUnmount() {
    }

    render() {
        return (
            <aside className="menu">
              <p className="menu-label">{I18n.get("Usuário")}</p>
              <ul className="menu-list">
                    <li className="is-disable">
                        <a>{I18n.get("Dashboard")}</a>
                    </li>
              </ul>
              <p className="menu-label">{I18n.get("Cadastro")}</p>
              <ul className="menu-list">
                <li>
                    <Link to="/cliente/usuario" className="is-black">{I18n.get("Responsável")}</Link>
                </li>
              </ul>
            </aside>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Menu);
